import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function LocalTrust() {
  return <section className="w-full bg-stone-100 dark:bg-[#252525] border-y border-stone-200 dark:border-white/5" data-id="element-564">
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-10 py-10 md:py-14" data-id="element-565">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-566">
          <div className="flex items-center gap-2 mb-3" data-id="element-567">
            <MapPinIcon className="w-4 h-4 text-brand-orange" data-id="element-568" />
            <span className="text-xs font-bold text-brand-orange uppercase tracking-widest" data-id="element-569">
              Locally Owned & Operated
            </span>
          </div>
          <p className="text-brand-charcoal/80 dark:text-white/80 text-base sm:text-lg leading-relaxed sm:leading-loose font-sub font-semibold" data-id="element-570">
            We're based in the{' '}
            <span className="text-brand-charcoal dark:text-white" data-id="element-571">
              253 area code
            </span>{' '}
            and deliver to{' '}
            <span className="text-brand-charcoal dark:text-white" data-id="element-572">
              Pierce County
            </span>{' '}
            and{' '}
            <span className="text-brand-charcoal dark:text-white" data-id="element-573">
              South King County
            </span>{' '}
            daily. No middlemen, no markups from national chains — just honest
            pricing on crushed rock, drain rock, topsoil, bark, and recycled
            aggregates delivered straight to your property.
          </p>
        </motion.div>
      </div>
    </section>;
}